import React from 'react';
import { Switch } from './switch';
import { Input } from './input';
import { Label } from './label';
import Typography from './typography';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './select';

interface SelectOption {
  value: string;
  label: string;
}

interface ToggleInputSectionProps {
  label: string;
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
  placeholder?: string;
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  showInput?: boolean;
  inputLabel?: string;
  inputType?: 'text' | 'date' | 'number' | 'multiselect' | 'select';
  inputProps?: React.ComponentProps<'input'>;
  selectOptions?: SelectOption[];
  children?: React.ReactNode;
}

const ToggleInputSection: React.FC<ToggleInputSectionProps> = ({
  label,
  isEnabled,
  onToggle,
  placeholder,
  value = '',
  onChange,
  showInput = true,
  inputLabel = 'Codes',
  inputType = 'text',
  inputProps = {},
  selectOptions = [],
  children,
}) => {
  return (
    <div className="flex flex-col space-y-3">
      <div className="flex items-center gap-2">
        <Switch
          checked={isEnabled}
          onCheckedChange={onToggle}
          className="data-[state=checked]:bg-primary-base"
        />
        <Label className="text-sm font-medium text-gray-400 dark:text-gray-300">
          {label}
        </Label>
      </div>
      {showInput && isEnabled && (
        <div className="flex flex-row items-center gap-1">
          <Typography
            color="neutral600"
            weight="normal"
            size="14"
            className="text-gray-600"
          >
            {inputLabel}
          </Typography>
          {children ? (
            children
          ) : inputType === 'select' ? (
            <Select
              value={typeof value === 'string' ? value : ''}
              onValueChange={(newValue) => onChange?.(newValue)}
            >
              <SelectTrigger className="text-sm h-10 min-w-[192px] w-[192px]">
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
              <SelectContent className="min-w-[192px]">
                {selectOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : (
            <Input
              type={inputType}
              placeholder={placeholder}
              value={typeof value === 'string' ? value : ''}
              onChange={(e) => onChange?.(e.target.value)}
              className={`text-sm h-10 w-1/1.6`}
              {...inputProps}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ToggleInputSection;
